import api from './api'

export const emailContactService = {
  getAllContacts: async (params = {}) => {
    const response = await api.get('/email-contacts', { params: { limit: 1000, ...params } })
    return response.data
  },

  getContactById: async (id) => {
    const response = await api.get(`/email-contacts/${id}`)
    return response.data
  },

  getContactAnalytics: async (id) => {
    const response = await api.get(`/email-contacts/${id}/analytics`)
    return response.data
  },

  getContactSegments: async (id) => {
    const response = await api.get(`/email-contacts/${id}/segments`)
    return response.data
  },

  createContact: async (data) => {
    const response = await api.post('/email-contacts', data)
    return response.data
  },

  updateContact: async (id, data) => {
    const response = await api.put(`/email-contacts/${id}`, data)
    return response.data
  },

  deleteContacts: async (ids) => {
    const response = await api.delete('/email-contacts', { data: { ids } })
    return response.data
  },

  bulkImport: async (rows, newCustomFields = []) => {
    const response = await api.post('/email-contacts/bulk-import', { rows, newCustomFields })
    return response.data
  },

  exportContacts: async () => {
    const response = await api.get('/email-contacts/export', { responseType: 'blob' })
    const url = window.URL.createObjectURL(new Blob([response.data]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', 'email-contacts.csv')
    document.body.appendChild(link)
    link.click()
    link.remove()
    window.URL.revokeObjectURL(url)
  }
}
